import * as React from "react";
const ButtonPill = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 9a3 3 0 1 1 0 6H7a3 3 0 1 1 0-6h10ZM7 8a4 4 0 1 0 0 8h10a4 4 0 0 0 0-8H7Z" }));
ButtonPill.displayName = "ButtonPill";
var ButtonPill_default = ButtonPill;
export {
  ButtonPill_default as default
};
